export const LANDING_PAGE_URL = "/provider/dashboard";
export const REQUISITION_URL = "/provider/requisition";
export const AUTH_CALLBACK_URL = "/provider/auth/callback";
export const LOGIN_PAGE_URL = "/provider/login";
export const UNIVERSAL_LOGIN_PAGE_URL = "/provider/login/universal";
export const TERMS_OF_USE_URL = "/provider/terms_of_use";
export const EMAIL_REPORT_URL_PREFIX = "/provider/emailReport";
export const MYPROFILE_URL = "/provider/myprofile";
export const REGISTER_URL = "/provider/signup";
export const RESET_PASSWORD_URL = "/provider/login/resetPassword";
export const RESET_PASSWORD_SENT_URL = "/provider/login/resetPassword/sent";
export const CONTACT_US_URL = "/provider/contactUs";
export const RELEASE_NOTES_URL = "/provider/release-notes";
export const VIDEO_PAGE_URL = "/provider/videos";
